import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch, useSelector } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { setLanguage } from "../../core/feature/language/languageSlice";
import { setToken } from "../../core/feature/token/tokenSlice";
import { setUser } from "../../core/feature/user/userSlice";
import { credentialCheck } from "../../core/service/api";
import { i18n } from "../../translations/i18n";
import { DashboardIcon } from "./icons";
import { Calendar, Check, ChevronLeft, ChevronRight } from "lucide-react";
import {
  getDashboardPerizinan,
  getPerizinanAll,
  getPerizinanOut,
} from "../../core/service/api_perizinan";
import { SwitchIcon } from "../savingComponent/icons";

const PERIZINAN_ACTIVE_CALLER_ID_KEY = "perizinan_active_caller_id";
const PERIZINAN_ACTIVE_CALLER_KEY = "perizinan_active_caller";

const PerizinanMobile = (props: any) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { token } = useParams();
  const [isToken, setIsToken] = useState<any>(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const callerIdFromUrl = searchParams.get("callerId");

  const user = useSelector((state: any) => state.user.user);
  const [caller, setCaller] = useState<any>(
    user?.accounts?.[0]?.callerIdentities?.[0],
  );
  const [dataPengajuan, setDataPengajuan] = useState<Perizinan[]>([]);
  const [dataKeluar, setDataKeluar] = useState<Perizinan[]>([]);
  const [selected, setSelected] = useState("pengajuan");
  const currentData = selected === "pengajuan" ? dataPengajuan : dataKeluar;
  const [dashboard, setDashboard] = useState({
    studentStatus: "",
    studentStatusLabel: "",
    totalIjinKeluarBulanIni: 0,
  });
  type optionsType = {
    value: number;
    label: string;
  };
  const now = new Date();

  const [yearOptions, setYearOptions] = useState<optionsType[]>(
    Array.from({ length: 6 }, (_, i) => {
      const year = now.getFullYear() + 1 - i;
      return { value: year, label: year.toString() };
    }),
  );

  const [isAccOpen, setIsAccOpen] = useState(false);

  const [activeCallerId, setActiveCallerId] = useState<string | null>(null);
  const [callerIdentities, setCallerIdentities] = useState<any[]>([]);

  const [filterYear, setFilterYear] = useState<number | "">(now.getFullYear());
  const [filterMonth, setFilterMonth] = useState<number | "">(
    now.getMonth() + 1,
  );

  const persistActiveCaller = (activeCaller: any) => {
    if (!activeCaller?.callerId) {
      localStorage.removeItem(PERIZINAN_ACTIVE_CALLER_ID_KEY);
      localStorage.removeItem(PERIZINAN_ACTIVE_CALLER_KEY);
      return;
    }

    localStorage.setItem(
      PERIZINAN_ACTIVE_CALLER_ID_KEY,
      activeCaller.callerId,
    );
    localStorage.setItem(
      PERIZINAN_ACTIVE_CALLER_KEY,
      JSON.stringify(activeCaller),
    );
  };

  const month = [
    { value: 1, label: "Januari" },
    { value: 2, label: "Februari" },
    { value: 3, label: "Maret" },
    { value: 4, label: "April" },
    { value: 5, label: "Mei" },
    { value: 6, label: "Juni" },
    { value: 7, label: "Juli" },
    { value: 8, label: "Agustus" },
    { value: 9, label: "September" },
    { value: 10, label: "Oktober" },
    { value: 11, label: "November" },
    { value: 12, label: "Desember" },
  ];

  useEffect(() => {
    try {
      const storedToken = localStorage.getItem("token_redux");
      const storedCallerId = localStorage.getItem(
        PERIZINAN_ACTIVE_CALLER_ID_KEY,
      );
      if (token) {
        localStorage.setItem("token_redux", token);
        dispatch(setToken(token));
      } else if (!storedToken) {
        navigate("/");
        return;
      }
      credentialCheck().then((resCredential) => {
        dispatch(setUser(resCredential.data.user));
        console.log("res credential ===========", resCredential.data.user);

        const identities =
          resCredential.data.user?.accounts?.[0]?.callerIdentities ?? [];
        if (!identities.length) {
          persistActiveCaller(null);
          navigate("/");
          return;
        }

        setCallerIdentities(identities);

        const resolvedCaller =
          identities.find((i: any) => i.callerId === callerIdFromUrl) ||
          identities.find((i: any) => i.callerId === storedCallerId) ||
          identities[0];

        console.log("[Valid Caller ID]", identities);

        setActiveCallerId(resolvedCaller.callerId);
        setCaller(resolvedCaller);
        persistActiveCaller(resolvedCaller);
      });
      // if (location.pathname.split("/")[2] != undefined) {
      //   setIsToken(true);
      //   dispatch(setToken(location.pathname.split("/")[2]));

      //   if (location.pathname.split("/")[3] != undefined) {
      //     var lang = location.pathname.split("/")[3];
      //     i18n.changeLanguage(lang);
      //     dispatch(setLanguage(lang));
      //   }
      // }
    } catch (error) {}
  }, [dispatch, navigate, token, callerIdFromUrl]);

  const fetchDashboard = async () => {
    if (!activeCallerId) return;

    try {
      const res = await getDashboardPerizinan({ callerId: activeCallerId });
      setDashboard(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchPengajuan = async () => {
    if (!activeCallerId) return;

    try {
      const params: Record<string, string> = {};
      if (filterYear) params.year = filterYear.toString();
      if (filterMonth) params.month = filterMonth.toString();
      params.callerId = activeCallerId;
      const res = await getPerizinanAll(params);
      const mapped = res.data.content.map((item: any) => ({
        id: item.id,
        status:
          item.status === "APPROVED"
            ? "approved"
            : item.status === "REJECTED"
              ? "rejected"
              : "pending",
        date: `${item.startDate} - ${item.endDate}`,
        teacherName: item.teacherName,
      }));
      setDataPengajuan(mapped);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchKeluar = async () => {
    if (!activeCallerId) return;

    try {
      const params: Record<string, string> = {};
      if (filterYear) params.year = filterYear.toString();
      if (filterMonth) params.month = filterMonth.toString();
      params.callerId = activeCallerId;
      const res = await getPerizinanOut(params);
      const mapped = res.data.content.map((item: any) => ({
        id: item.id,
        status: item.status,
        date: `${item.startDate} - ${item.endDate}`,
        teacherName: item.teacherName,
      }));
      setDataKeluar(mapped);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!activeCallerId) return;

    fetchDashboard();
    fetchPengajuan();
    fetchKeluar();
  }, [filterYear, filterMonth, activeCallerId]);

  type Perizinan = {
    id: string;
    status: "approved" | "pending" | "rejected";
    date: string;
    teacherName: string;
  };

  const PerizinanType = {
    approved: {
      title: "Disetujui",
      icon: "bg-[#18AF69]",
      text: "text-[#18AF69]",
    },
    pending: {
      title: "Menunggu",
      icon: "bg-[#FFBE0C]",
      text: "text-[#FFBE0C]",
    },
    rejected: {
      title: "Ditolak",
      icon: "bg-[#FF0000]",
      text: "text-[#FF0000]",
    },
  };

  const dataButtons = [
    {
      id: "pengajuan",
      title: "Riwayat Pengajuan",
    },
    {
      id: "keluar",
      title: "Riwayat Keluar",
    },
  ];

  const Pengajuan = ({ item }: { item: Perizinan }) => {
    return (
      <div className="flex items-center justify-between h-full py-2 bg-white rounded-3xl px-4">
        <div className="flex items-center">
          <div
            className={`w-12 h-12 flex items-center justify-center rounded-full ${PerizinanType[item.status].icon}`}
          >
            <DashboardIcon className="w-6 h-6 text-white" />
          </div>
          <div className="flex flex-col px-3 leading-tight">
            <span className={`text-sm ${PerizinanType[item.status].text}`}>
              {PerizinanType[item.status].title}
            </span>
            <span className="text-gray-500 text-xs">{item.date}</span>
            <span className="text-md mt-1">{item.teacherName}</span>
          </div>
        </div>
        <button className="w-6 h-6 rounded-full flex items-center justify-center bg-psp-btn-primary">
          <ChevronRight className="w-4 h-4 text-white" />
        </button>
      </div>
    );
  };

  const Keluar = ({ item }: { item: Perizinan }) => {
    return (
      <div className="flex items-center justify-between h-full py-3 bg-white rounded-3xl px-4">
        <div className="flex items-center">
          <div
            className={`w-12 h-12 flex items-center justify-center rounded-full bg-[#18AF69]`}
          >
            <DashboardIcon className="w-6 h-6 text-white" />
          </div>
          <div className="flex flex-col px-3 leading-tight">
            <span className="text-gray-500 text-xs">{item.date}</span>
            <span className="text-md mt-1">{item.teacherName}</span>
          </div>
        </div>
        <button
          className={`w-6 h-6 rounded-full flex items-center justify-center bg-psp-btn-primary`}
        >
          <ChevronRight className="w-4 h-4 text-white" />
        </button>
      </div>
    );
  };

  return (
    <div className="h-screen overflow-hidden px-4 py-6 bg-psp-primary top-to-bottom font-montserrat">
      <div className="flex flex-col h-full">
        <div className="flex-1 overflow-y-auto scrollbar-hide pb-24">
          <div className="flex-none">
            <section className="flex flex-col">
              <div className="flex d-flex w-full mb-8">
                <button>
                  <ChevronLeft
                    className="bg-white w-8 h-8 rounded-lg border p-1"
                    onClick={() => navigate(`/home`)}
                  />
                </button>
                <div className="absolute left-1/2 -translate-x-1/2 font-bold text-md">
                  Riwayat Perizinan
                </div>
              </div>
              <div className="flex flex-row h-full py-3 bg-white w-full rounded-3xl border">
                <div className="flex flex-row items-center w-full ml-2">
                  <div className="w-20 h-20 p-2">
                    <img
                      src={
                        caller?.photoUrl ||
                        "https://i.pinimg.com/736x/9e/83/75/9e837528f01cf3f42119c5aeeed1b336.jpg"
                      }
                      alt=""
                      className="rounded-xl"
                    />
                  </div>
                  <div className="flex justify-between">
                    <h1
                      style={{ fontSize: 16 }}
                      className={`text-sm flex flex-col justify-center font-montserrat`}
                    >
                      {caller?.name}
                    </h1>
                  </div>
                </div>
                {callerIdentities.length > 1 && (
                  <div className="flex items-center my-auto mr-3">
                    <button
                      className="w-[40px] h-[40px] bg-psp-btn-primary p-2 rounded-3xl mt-0 text-white mr-4 flex d-flex"
                      onClick={() => setIsAccOpen(true)}
                    >
                      <SwitchIcon />
                    </button>
                  </div>
                )}
              </div>
            </section>
            <section className="mt-3 mb-2">
              <div className="flex flex-row gap-3 justify-between">
                <div className=" h-full p-2 bg-white rounded-xl flex flex-col justify-between border">
                  <div className="px-1">
                    <p className="text-md text-gray-500 mb-1">Status Siswa</p>
                    <strong>
                      <p className="text-md text-psp-primary mb-1">
                        {dashboard.studentStatus
                          ?.toLowerCase()
                          .replaceAll("_", " ")
                          .replace(/^\w/, (c) => c.toUpperCase())}
                      </p>
                    </strong>
                    <p className="text-gray-500 mb-1" style={{ fontSize: 14 }}>
                      {dashboard.studentStatusLabel}
                    </p>
                  </div>
                </div>
                <div className="flex-1 h-full bg-white rounded-xl p-2 flex flex-col justify-between border">
                  <div className="pl-1">
                    <p className="text-md text-gray-500 mb-1">Total Izin</p>
                    <strong>
                      <p className="text-md mb-1">
                        {dashboard.totalIjinKeluarBulanIni}
                      </p>
                    </strong>
                    <p className="text-gray-500 mb-1" style={{ fontSize: 14 }}>
                      / Bulan
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="sticky top-0 z-20 bg-psp-primary pt-1">
            <section className="mb-2">
              <div className="flex flex-row flex-nowrap items-center justify-between px-2">
                {dataButtons.map((dataButton) => {
                  const isActive = selected === dataButton.id;
                  return (
                    <div key={dataButton.id}>
                      <button
                        onClick={() => setSelected(dataButton.id)}
                        className={`h-10 w-full rounded-3xl transition-colors duration-200 ${
                          isActive
                            ? "text-psp-primary font-bold underline underline-offset-[14px] decoration-2"
                            : "text-black"
                        }`}
                      >
                        {dataButton.title}
                      </button>
                    </div>
                  );
                })}
              </div>
            </section>
            <section className="pb-2">
              <strong>
                <p className="ml-3 mb-2">Filter</p>
              </strong>
              <div className="flex flex-row gap-2 mb-3 items-center justify-between px-2">
                <div className="flex items-center gap-2 bg-white border rounded-md px-2 py-1 flex-1">
                  <Calendar className="w-5 h-5" />
                  <select
                    className="outline-none text-sm h-8 rounded-full w-full p-1"
                    value={filterYear}
                    onChange={(e) => setFilterYear(Number(e.target.value))}
                  >
                    {yearOptions.map((option: any) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex items-center gap-2 bg-white border rounded-md px-2 py-1 flex-1">
                  <Calendar className="w-5 h-5 text-gray-500" />
                  <select
                    value={filterMonth}
                    onChange={(e) => setFilterMonth(Number(e.target.value))}
                    className="outline-none text-sm h-8 rounded-full w-full p-1"
                  >
                    {month.map((month) => (
                      <option key={month.value} value={month.value}>
                        {month.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </section>
          </div>
          <section className="mb-4 flex flex-col gap-3">
            {currentData.length === 0 ? (
              <p className="text-center text-gray-500 py-6">Tidak ada data</p>
            ) : selected === "pengajuan" ? (
              currentData.map((item) => (
                <div
                  key={item.id}
                  onClick={() => navigate(`/perizinan/${item.id}/detail`)}
                >
                  <Pengajuan item={item} />
                </div>
              ))
            ) : (
              currentData.map((item) => (
                <div
                  key={item.id}
                  onClick={() => navigate(`/perizinan/${item.id}/detail`)}
                >
                  <Keluar item={item} />
                </div>
              ))
            )}
          </section>
        </div>
        <div className="fixed bottom-0 left-0 w-full px-4 pb-2 bg-psp-primary flex-none">
          <section className="mt-2">
            <button
              className="w-full h-full py-2 bg-psp-btn-primary rounded-3xl text-white"
              onClick={() =>
                navigate(`/perizinan/form`, {
                  state: {
                    activeCallerId: activeCallerId,
                    activeCallerName: caller?.name,
                  },
                })
              }
            >
              Tambahkan Perizinan
            </button>
          </section>
        </div>
      </div>
      <section>
        {isAccOpen && (
          <div className="fixed inset-0 z-50 flex items-end justify-center">
            <div
              className="absolute inset-0 bg-black/40"
              onClick={() => setIsAccOpen(false)}
            ></div>
            <div className="relative w-full bg-white rounded-t-2xl p-4 animate-slideUp">
              <span className="mb-2 ml-4 mt-3 font-bold">Ganti Akun</span>
              {callerIdentities.map((item) => {
                const isSelected = item.callerId === activeCallerId;
                return (
                  <div
                    key={item.callerId}
                    className="flex items-center justify-between h-20 px-4"
                    onClick={() => {
                      // resetSaving();
                      setActiveCallerId(item.callerId);
                      setCaller(item);
                      persistActiveCaller(item);
                      setIsAccOpen(false);
                    }}
                  >
                    <img
                      src={
                        item.photoUrl ||
                        "https://i.pinimg.com/736x/9e/83/75/9e837528f01cf3f42119c5aeeed1b336.jpg"
                      }
                      alt=""
                      className="w-12 h-12 rounded-full object-cover"
                    />
                    <div className="flex-1 ml-4">
                      <div className="flex flex-col leading-tight">
                        <span>{item.name}</span>
                        <span className="text-gray-500 text-sm">
                          {item.callerId}
                        </span>
                      </div>
                    </div>
                    {isSelected ? (
                      <div className="w-6 h-6 bg-[#0054E6] rounded-full flex items-center justify-center">
                        <Check className="w-4 h-4 text-white" />
                      </div>
                    ) : (
                      <ChevronRight />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default PerizinanMobile;
